<template>
<div id="app" style="width:100%;height:100%">
    <router-view />
</div>
</template>

<script>
export default {
    name: 'App'
}
</script>
<style>
    .nav-item .el-menu.el-menu--horizontal {
        background: transparent;
        border: none;
    }
    .nav-item .el-menu--horizontal>.el-submenu .el-submenu__title {
        color: #fff;
        border: none;
    }
    .nav-item .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
        color: #ffffff;
        font-weight: bold;
    }
    .nav-item .el-submenu__title:hover {
        background: transparent!important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue